<template>
  <el-dialog
    :title="form.afterId ? '编辑' : '新增'"
    :visible.sync="formVisible"
    :close-on-click-modal="false"
    width="1200px"
    v-if="formVisible"
  >
    <el-form
      ref="dataForm"
      :rules="formRules"
      :model="form"
      label-position="right"
      size="small"
      label-width="120px"
    >
      <el-form-item label="认领人员：" prop="customerId">
        <el-select
          v-model="form.customerId"
          value-key="value"
          placeholder="根据姓名/手机号搜索"
          filterable
          clearable
          remote
          :remote-method="searchUsers"
          :loading="isLoading"
        >
          <el-option
            v-for="(it, idx) in userList"
            :label="
              it.name +
                (it.pho ? '(' + it.pho + ')' : '') +
                (it.customerLevelName ? '(' + it.customerLevelName + ')' : '')
            "
            :key="idx"
            :value="it.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="快递单号：" prop="logisticsNumber">
        <el-input v-model="form.logisticsNumber" placeholder="请输入快递单号" />
      </el-form-item>
      <el-form-item label="售后商品：" class="is-required" prop="goodsList">
        <div class="table-list mt20">
          <div class="spec-head">
            <div class="sp-col flex25">售后商品</div>
            <div class="sp-col flex05-half">验收数量</div>
            <div class="sp-col flex05-half">零售价格</div>
            <div class="sp-col flex05-half">入库信息</div>
            <div class="sp-col">批次号</div>
            <div class="sp-col">有效期</div>
            <div class="sp-col flex05">操作</div>
          </div>
          <div
            class="spec-item"
            v-for="(item, idx) in form.goodsList"
            :key="idx"
          >
            <el-form-item
              class="sp-col flex25"
              :prop="`goodsList[${idx}].goodsIdArr`"
              label-width="0"
              :rules="{ required: true, message: '请选择', trigger: 'change' }"
            >
              <!-- <el-select v-model="item.goodsId" placeholder="请选择" filterable clearable>
                <el-option v-for="it in sysGoods" :key="it.id" :label="it.name" :value="it.id"></el-option>
              </el-select> -->
              <el-cascader
                v-model="item.goodsIdArr"
                :props="cascaderProps"
                :options="sysGoods"
                placeholder="请选择售后商品"
                filterable
                clearable
                @expand-change="(val) => handleExpandChange(val, idx)"
                @change="getGoodsGG(idx)"
              />
            </el-form-item>
            <el-form-item
              class="sp-col flex05-half"
              :prop="`goodsList[${idx}].acceptanceQuantity`"
              label-width="0"
              :rules="{ required: true, message: '请填写', trigger: 'change' }"
            >
              <el-input
                v-model="item.acceptanceQuantity"
                placeholder="请输入验收数量"
              />
            </el-form-item>
            <el-form-item
              class="sp-col flex05-half"
              :prop="`goodsList[${idx}].retailPrice`"
              label-width="0"
              :rules="{ required: true, message: '请选择', trigger: 'change' }"
            >
              <el-input
                v-model="item.retailPrice"
                placeholder="请输入"
                disabled
              />
            </el-form-item>
            <el-form-item
              class="sp-col flex05-half"
              :prop="`goodsList[${idx}].inBoundQuantity`"
              label-width="0"
              :rules="{ required: true, message: '请选择', trigger: 'change' }"
            >
              <el-input
                v-model="item.inBoundQuantity"
                placeholder="请输入入库信息"
              />
            </el-form-item>
            <el-form-item
              class="sp-col"
              :prop="`goodsList[${idx}].batchNumber`"
              label-width="0"
              :rules="{ required: true, message: '请选择', trigger: 'change' }"
            >
              <el-input v-model="item.batchNumber" placeholder="请输入批次号" />
            </el-form-item>
            <el-form-item
              class="sp-col"
              :prop="`goodsList[${idx}].expirationDate`"
              label-width="0"
              :rules="{ required: true, message: '请选择', trigger: 'change' }"
            >
              <el-date-picker
                v-model="item.expirationDate"
                type="date"
                placeholder="请选择"
                style="width: 100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <div class="sp-col oper-icon flex05">
              <i
                class="el-icon-minus"
                @click="handleDeleteItem(idx)"
                v-if="form.goodsList.length > 1"
              ></i>
              <i class="el-icon-plus" @click="handleAddItem"></i>
            </div>
          </div>
        </div>
        <div class="statistics-box">
          <div class="statistics-item">
            <span class="statistics-label">总验货数量:</span>
            <span class="statistics-value"
              >{{ totalAcceptanceQuantity }}件</span
            >
          </div>
          <div class="statistics-item">
            <span class="statistics-label">验货商品总价(零售价):</span>
            <span class="statistics-value">{{ totalRetailPrice }}元</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="申请原因：" prop="applyReason">
        <el-input v-model="form.applyReason" placeholder="请输入申请原因" />
      </el-form-item>
      <el-form-item label="附件(最多9张)：" prop="attachment">
        <moreImageUpload v-model="form.attachment" :limit="9" />
      </el-form-item>
      <el-form-item label="备注：" prop="remarks">
        <el-input v-model="form.remarks" placeholder="请输入备注" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import goodsOrderApi from "@/api/order/goodsOrder";
import sysGoodsApi from "@/api/sys/sysGoods";
import MoreImageUpload from "@/components/MoreImageUpload";
import { accAdd, accMul } from "@/utils/index";
function initFormBean() {
  const formBean = {
    customerId: null,
    logisticsNumber: null,
    goodsList: [
      {
        goodsId: "",
        acceptanceQuantity: "",
        batchNumber: "",
        inBoundQuantity: "",
        expirationDate: ""
      }
    ],
    applyReason: null,
    remarks: null
  };
  return formBean;
}

export default {
  components: {
    MoreImageUpload
  },
  data() {
    return {
      cascaderProps: {
        label: "name",
        value: "id",
        children: "children"
      },
      form: initFormBean(),
      formVisible: false,
      formRules: {
        logisticsNumber: [
          { required: true, message: "请输入快递单号", trigger: "blur" }
        ]
      },
      isRepSub: false,
      sysGoods: [],
      userList: [],
      isLoading: false // 添加 loading 状态
    };
  },
  computed: {
    // 计算总验货数量
    totalAcceptanceQuantity() {
      return this.form.goodsList.reduce((total, item) => {
        const quantity = parseFloat(item.acceptanceQuantity) || 0;
        return accAdd(total, quantity);
      }, 0);
    },
    // 计算验货商品总价(零售价)
    totalRetailPrice() {
      const total = this.form.goodsList.reduce((total, item) => {
        const quantity = parseFloat(item.acceptanceQuantity) || 0;
        const price = parseFloat(item.retailPrice) || 0;
        const itemTotal = accMul(quantity, price);
        return accAdd(total, itemTotal);
      }, 0);
      // 保留两位小数，如果是整数则不显示小数
      return total % 1 === 0 ? total : total.toFixed(2);
    }
  },
  created() {
    this.getGoods();
  },
  methods: {
    handleEdit(row) {
      this.resetForm();
      this.form.afterId = row.id;
      this.form.logisticsNumber = row.deliverInfo || "";
      this.form.applyReason = row.applyReason;
      this.form.remarks = row.remarks;
      let arr = [];
      row.goodsList.forEach(item => {
        arr.push({
          goodsId: item.platformProductId,
          acceptanceQuantity: item.afterGoodsCount,
          batchNumber: item.batchNumber,
          inBoundQuantity: item.inBoundQuantity,
          expirationDate: item.expirationDate,
          goodsIdArr:
            item.platformProductId && item.platformCombineId
              ? [item.platformProductId, item.platformCombineId]
              : [],
          retailPrice: item.retailPrice
        });
      });
      this.form.goodsList = arr;
      if (row.customerId) {
        this.form.customerId = row.customerId;
        this.userList = [
          {
            id: row.customerId,
            name: row.customerInfo && row.customerInfo.name,
            pho: row.customerInfo && row.customerInfo.pho
          }
        ];
      }
      this.$set(this.form, "attachment", this.clacArrObj(row.attachment));
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    clacArrObj(str) {
      if (!str) return [];
      let arr = str.split(",");
      let newArr = [];
      arr.forEach((item, index) => {
        newArr.push({ url: item, uid: "a_" + index });
      });
      return newArr;
    },
    handleAdd() {
      this.resetForm();
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    getGoods() {
      sysGoodsApi.getGoodRecomList().then(({ data }) => {
        this.sysGoods = data;
        this.sysGoods.forEach(item => {
          item.name = item.name + (item.aliasName ? ' [' + item.aliasName + ']' : '')
          item.children = item.specValueList.map(it => ({
            id: it.id,
            // REQ-2026-234328 产品规格优先，回退老的自由文本「商品规格」——
            // product_spec 没有存量回填，只取新字段会让历史商品这一栏空白
            name: item.productSpec || item.spec || '无规格值',
            retailPrice: it.retailPrice
          }));
        });
      });
    },
    searchUsers(query) {
      if (query !== "") {
        this.isLoading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.isLoading = false;
          this.getUserList(query);
        }, 500);
      } else {
        this.userList = [];
      }
    },
    getUserList(query) {
      goodsOrderApi
        .getUserList({
          state: 1,
          isDeparted: 0,
          nameOrPho: query,
          pageNo: 1,
          pageSize: 100
        })
        .then(res => {
          let { list } = res.data;
          let arr = [];
          list &&
            list.forEach(item => {
              let { id, name, pho } = item.customer;
              arr.push({
                id,
                name,
                pho,
                customerLevelName: item.customerLevel.name
              });
            });
          this.userList = arr;
        });
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.userList = [];
      this.form = initFormBean();
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm();
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    handleUpdate(row) {
      this.resetForm();
      this.form = { ...row };

      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    calcEditData() {},
    handleExpandChange(val, idx) {
      if (val && val.length === 1) {
        const parent = this.sysGoods.find(item => item.id === val[0])
        if (parent && parent.children && parent.children.length === 1) {
          this.$set(this.form.goodsList[idx], 'goodsIdArr', [val[0], parent.children[0].id])
        }
      }
    },
    getGoodsGG(idx) {
      const selectedValue = this.form.goodsList[idx].goodsIdArr;
      if (selectedValue && selectedValue.length > 0) {
        // 获取选中的商品ID（级联选择器的最后一个值）
        const selectedProductId = selectedValue[selectedValue.length - 1];

        // 在商品列表中查找对应的零售价格
        this.sysGoods.forEach(item => {
          if (item.children) {
            const foundChild = item.children.find(
              child => child.id === selectedProductId
            );
            if (foundChild) {
              // 使用 $set 确保响应式更新
              this.$set(
                this.form.goodsList[idx],
                "retailPrice",
                foundChild.retailPrice
              );
            }
          }
        });
      } else {
        // 如果没有选择商品，清空零售价
        this.$set(this.form.goodsList[idx], "retailPrice", "");
      }
    },
    calcParams() {
      let params = JSON.parse(JSON.stringify(this.form));
      params.attachment =
        params.attachment && params.attachment.length
          ? params.attachment.map(banner => banner.url).toString()
          : "";
      params.goodsList.forEach(item => {
        if (item.goodsIdArr && Array.isArray(item.goodsIdArr)) {
          item.goodsId = item.goodsIdArr[0];
          item.platformCombineId = item.goodsIdArr[1];
        }
        item.acceptanceQuantity = +item.acceptanceQuantity;
        item.goodsCount = +item.acceptanceQuantity;
        delete item.goodsIdArr;
        delete item.isApp;
      });
      return params;
    },
    doCreate() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          let params = this.calcParams();
          if (this.isRepSub) return;
          this.isRepSub = true;
          if (this.form.afterId) {
            goodsOrderApi
              .EditCustomerOrderAfter(params)
              .then(data => {
                this.postCallback(data);
              })
              .catch(res => {
                this.isRepSub = false;
              });
          } else {
            goodsOrderApi
              .AddCustomerOrderAfter(params)
              .then(data => {
                this.postCallback(data);
              })
              .catch(res => {
                this.isRepSub = false;
              });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false;
      this.$message.success("操作成功");
      this.formVisible = false;
      this.tabType = 1;
      this.$emit("created");
    },
    handleDeleteItem(index) {
      this.form.goodsList.splice(index, 1);
    },
    handleAddItem() {
      this.form.goodsList.push({ goodsId: "", acceptanceQuantity: "" });
    }
  }
};
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  // padding: 10px 0;
}

.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

// .el-form-item--small.el-form-item {
//   width: 48%;
//   display: inline-block;
//   vertical-align: top;
// }
// .el-form-item--small.el-form-item.width100 {
//   width: 97%;
// }
::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}

.table-list {
  border: 1px solid #e4e4e4;
  // margin: 0 35px 20px 50px;
  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;
    min-width: 0;
    &.flex05 {
      flex: 0.5;
    }
    &.flex05-half {
      flex: 0.8;
    }
    &.flex25 {
      flex: 1.6;
    }
    &.flex2 {
      // flex-grow: 3;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }

      ::v-deep .el-cascader {
        width: 100%;
      }

      ::v-deep .el-form-item {
        width: 100%;
        margin-bottom: 0;
      }

      ::v-deep .el-form-item__content {
        width: 100%;
      }
    }
  }
}
.oper-icon {
  i {
    cursor: pointer;
    font-size: 22px;
    color: #465c99;
    &:nth-child(1) {
      padding-right: 5px;
    }
  }
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}

.statistics-box {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 15px;
  padding: 10px 0;
  gap: 30px;
}

.statistics-item {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.statistics-label {
  color: #666;
  margin-right: 5px;
}

.statistics-value {
  color: #f56c6c;
  font-weight: 500;
}
</style>
